import { render, staticRenderFns } from "./IndexDialog.vue?vue&type=template&id=59e52e6e&scoped=true&"
import script from "./IndexDialog.vue?vue&type=script&lang=js&"
export * from "./IndexDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e52e6e",
  null
  
)

export default component.exports